import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FileView from "components/fileView";
import { LoadingIcon } from "utils/constant";
import { useToast } from "contexts/ToastContext";
import { useAuth } from "contexts/AuthContext";
import { StatusChip } from "components/StatusChip";
import DocumentViewerModal from "components/DocumentViewer";
import UploadTrainingReport from "./uploadTraningReport";
import { useTranslation } from "react-i18next";

function LegalAdvisoryDetailZone({ request }: { request: any }) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [publicFeedback, setPublicFeedback] = useState(false);
    const [uploadAmend, setUploadAmend] = useState(false);
    const [auditDraft, setAuditDraft] = useState(false);
    const [showDraftHistory, setShowDraftHistory] = useState(false);
    const [edit, setEdit] = useState(false);
    const [formState, setFormState] = useState({ ...request });
    const contextData = useAuth();
    const { showToast } = useToast();
    const [viewTeam, setViewTeam] = useState(false);
    const [isTargetModalOpen, setIsTargetModalOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDistributeModalOpen, setIsDistributeModalOpen] = useState(false);

    const handleTargetCloseModal = () => {
        setIsTargetModalOpen(false);
    }
    const handleCloseModal = () => {
        setIsModalOpen(false);
    }
    const handleUploadProposalClick = () => {
    }

    const [isRespondBackFormOpen, setIsRespondBackFormOpen] = useState(false);

    const handleFileChange = (
        file: any,
        fieldName: keyof Pick<
            typeof formState,
            "audit_summary_file"
        >
    ) => {
        setFormState((prev: any) => ({
            ...prev,
            [fieldName]: file,
        }));
    };

    const handleChange = (
        e: React.ChangeEvent<
            HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
        >
    ) => {
        const { name, value } = e.target;
        setFormState((prev: any) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleRespondBackClick = () => {
        setIsRespondBackFormOpen(!isRespondBackFormOpen);
    }

    const handleForward = async (froward_status: string) => {
    };

    // Get button text based on whether report summary exists
    const getButtonText = () => {
        if (formState.report_summary) {
            return t("ReUploadTrainingReport") || "ReUpload Training Report";
        }
        return t("UploadTrainingReport") || "Upload Training Report";
    };

    return (
        <div className="flex-1 bg-gray-100 mx-4 rounded-lg overflow-y-scroll scrollbar-hide">
            <div className="flex flex-col max-w-4xl bg-white rounded-lg shadow-md p-6">
                {/* Header */}
                <div className="flex items-center justify-between pb-4 mb-3">
                    <div className="flex items-center space-x-2">
                        <button
                            onClick={() => navigate("/legal-training-provision")}
                            className="text-gray-600 hover:text-gray-800"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M15 19l-7-7 7-7"
                                />
                            </svg>
                        </button>
                    </div>
                    <h1 className="text-2xl font-semibold text-gray-800 ml-8">
                        {t("RequestForLegalTrainingProvision") || "Request for Legal Training Provision"}
                    </h1>
                    <div className="ml-auto">
                        <StatusChip status={formState.status} />
                    </div>
                    <div>
                    </div>
                </div>
                
                <div className="mt-6 space-y-4 border border-gray-400 p-4 mb-8 rounded-lg">
                    <div className="mb-8">
                        <p className="text-[#432101AB] font-normal text-base">
                            {t("TrainingSentFrom", { adminUnit: formState.admin_unit_name }) || `Training sent from ${formState.admin_unit_name}`}
                        </p>
                        <p className="text-gray-500 font-medium mb-2">
                            {formState?.report_summary}
                        </p>
                    </div>
                    
                    {formState?.documents?.find((document: any) => document.document_type === "distributed_training_zone_file") &&
                        <>
                            <DocumentViewerModal
                                documents={formState?.documents.filter((document: any) => document.document_type === "distributed_training_zone_file")}
                                baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_training_provision/legal-training-provision-documents/document/`}
                            />
                        </>
                    }
                    
                    {formState?.documents?.find((document: any) => document.document_type === "distributed_report_zone_file") &&
                        <>
                            {formState?.entry_registr &&
                                <p className="text-[#432101AB] font-normal text-base">
                                    {t("RegisterNumber") || "Register Number"}: {formState.entry_registr}
                                </p>
                            }
                            {formState.request_letter_ref_no &&
                                <p className="text-[#432101AB] font-normal text-base">
                                    {t("RequestLetterNumber") || "Request Letter Number"}: {formState?.request_letter_ref_no}
                                </p>}
                            <DocumentViewerModal
                                documents={formState?.documents.filter((document: any) => document.document_type === "distributed_report_zone_file")}
                                baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_training_provision/legal-training-provision-documents/document/`}
                            />
                        </>
                    }
                </div>

                {(formState?.documents?.filter((document: any) => document.document_type === "training_manual_file").length > 0 || formState?.summary) && (
                    <div className="mt-6 space-y-4 border border-gray-400 p-4 mb-8 rounded-lg">
                        <p className="text-[#432101AB] font-normal text-base mb-4">{t("TrainingManual") || "Training Manual"}</p>
                        {formState?.documents?.filter((document: any) => document.document_type === "training_manual_file").length > 0 && (
                            <div>
                                {(() => {
                                    const trainingManualDocuments: any[] = formState?.documents.filter((document: any) => document.document_type === "training_manual_file").sort((a: any, b: any) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
                                    const latestDocument = trainingManualDocuments[0];
                                    const previousDocuments = trainingManualDocuments.slice(1);
                                    
                                    return (
                                        <div>
                                            <div className="mb-4">
                                                <p className="text-sm text-gray-600 mb-2">{t("LatestVersion") || "Latest Version"}</p>
                                                <DocumentViewerModal
                                                    documents={[latestDocument]}
                                                    baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_training_provision/legal-training-provision-documents/document`}
                                                />
                                            </div>
                                            {previousDocuments.length > 0 && (
                                                <div>
                                                    <details className="border border-gray-300 rounded-lg">
                                                        <summary className="p-3 cursor-pointer bg-gray-50 hover:bg-gray-100 rounded-lg">
                                                            <span className="font-medium">{t("PreviousVersions", { count: previousDocuments.length }) || `Previous Versions (${previousDocuments.length})`}</span>
                                                        </summary>
                                                        <div className="p-3 space-y-3">
                                                            {previousDocuments.map((doc: any, index: number) => (
                                                                <div key={doc.document_uuid} className="border border-gray-200 rounded-lg p-2">
                                                                    <p className="text-xs text-gray-500 mb-1">
                                                                        {t("Version") || "Version"} {previousDocuments.length - index} - {new Date(doc.created_at).toLocaleDateString()}
                                                                    </p>
                                                                    <DocumentViewerModal
                                                                        documents={[doc]}
                                                                        baseUrl={`${process.env.REACT_APP_API_BASE_URL}legal_training_provision/legal-training-provision-documents/document`}
                                                                        hideEmptyFile={true}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </details>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })()}
                            </div>
                        )}
                        {formState?.summary && (
                            <div className="mb-8 mt-4">
                                <p className="text-[#432101AB] font-normal text-base">{t("TrainingManualSummary") || "Training Manual Summary"}</p>
                                <p className="text-gray-500 font-medium mb-2">
                                    {formState?.summary}
                                </p>
                            </div>
                        )}
                    </div>
                )}
                
                {!formState.report_summary &&
                    <div className="mt-4 flex flex-col sm:flex-row justify-between space-y-4 sm:space-y-0 sm:space-x-4">
                        <button
                            type="button"
                            className="ml-auto px-6 py-3 rounded-md bg-[#D4D4D4] text-[#212121] font-semibold hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300"
                            onClick={() => setIsModalOpen(true)}
                            disabled={loading}
                        >
                            {loading ? (
                                <div className="flex items-center justify-center">
                                    {LoadingIcon} {t("Submitting") || "Submitting..."}
                                </div>
                            ) : (
                                getButtonText()
                            )}
                        </button>
                    </div>
                }
                
                <UploadTrainingReport
                    request={formState}
                    setLegalResearch={setFormState}
                    isOpen={isModalOpen}
                    onClose={handleCloseModal}
                    onUploadProposal={handleUploadProposalClick}
                />
            </div>
        </div>
    );
}

export default LegalAdvisoryDetailZone;